document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('[data-toggle]').forEach(function (togglerElement) {
		if (togglerElement.dataset.toggle === 'class') {
			togglerElement.addEventListener('click', function (event) {
				togglerElement.classList.toggle(togglerElement.dataset.selfClass);
				event.preventDefault();
				document.querySelectorAll(togglerElement.dataset.target).forEach(function (element) {
					element.classList.toggle(togglerElement.dataset.class);
				});
			});
		}
	});
});